/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlanTypeResponseDto { 
    /**
     * Unique identifier for the plan type (Element ID)
     */
    id: string;
    /**
     * URL-friendly slug for the plan type
     */
    slug: string;
    /**
     * Display name of the plan type
     */
    display: string;
    /**
     * Description of the plan type
     */
    description?: string;
    /**
     * Status of the plan type
     */
    status: PlanTypeResponseDto.StatusEnum;
    /**
     * Collection ID this plan type belongs to
     */
    collectionId: string;
    /**
     * JSON Schema for validating plan records
     */
    recordSchema?: any;
    /**
     * Additional metadata for the plan type
     */
    metadata?: any;
    /**
     * Form identifier associated with the plan type
     */
    formId?: string;
    /**
     * Creation timestamp
     */
    createdOn: string;
    /**
     * Last update timestamp
     */
    updatedOn: string;
}
export namespace PlanTypeResponseDto {
    export type StatusEnum = 'active' | 'inactive';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


